



































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Connector from '@vue-polkadot/vue-api';
import ItemCard from '@/components/shared/wrapper/ItemCard.vue'
import Money from '@/components/shared/format/Money.vue'
import WithLabel from '@/components/shared/format/WithLabel.vue'
import { AccountId } from '@polkadot/types/interfaces';
import { DeriveStakingQuery } from '@polkadot/api-derive/types';
import { StakingState, expandInfo } from './utils'
import Nominators from './Nominators.vue'

const components = {
  ItemCard,
  Money,
  WithLabel,
  Nominators
}

@Component({ components })
export default class ValidatorRow extends Vue {
  @Prop() public validatorId!: AccountId;
  @Prop() public rewardPoints!: string;
  private nominatorsVisible = false;
  private loading: boolean = false;
  private stakingInfo: StakingState = {
    nominators: []
  };

  public async mounted() {
    const { validatorId } = this;
    const { api } = Connector.getInstance()

    try {
      this.loading = true;
      const stakingInfo = await api.derive.staking.query(validatorId);
      this.stakingInfo = expandInfo(stakingInfo)
    } catch (e) {
      console.warn(e);
    } finally {
      this.loading = false;
    }
  }

  private handleNominatorsVisibility() {
    this.nominatorsVisible = !this.nominatorsVisible;
  }
}
